import React, { Component } from "react";

// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col,
  Button,
  Tooltip,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import API from "api.js";
import { base, s3base } from "api.js";
import { NavLink } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import { setAlert } from "action/index.js";
import { store } from "store/index";
// core components
import TemplateDetectorModal from "components/PracticeMaterial/PopUps/TemplateDetectorModal";

class ShowHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      modal: false,
      id: 0,
      deleteFlag: true,
      loadMoreFlag: false,
      load_flag: false,
      scoreData: [],
      explanationModal: false,
      popupData: {}
    };
  }

  componentDidMount() {
    this.getData();
  }

  closeModalExplanation = () => {
    this.setState({ explanationModal: false });
  };

  getData() {
    this.setState({
      load_flag: true,
    });

    var bodyFormData = new FormData();
    bodyFormData.set("question_id", this.props.question);

    if (parseInt(this.props.all) === 1) {
      bodyFormData.set("all", 1);
    }

    bodyFormData.set("skip", this.state.data.length);

    API({
      method: "POST",
      url: "show/history",
      data: bodyFormData,
    }).then((data) => {
      if (data.status === 200) {
        let loadMoreFlag = true;
        if (data.data.data.length < 10) {
          loadMoreFlag = false;
        }
        this.setState({
          loadMoreFlag: loadMoreFlag,
          load_flag: false,
          data: [...this.state.data, ...data.data.data],
        });
      }
    });
  }

  showScore = (e, id, category) => {
    this.setState({
      modal: !this.state.modal,
      id
    });
  };

  deleteComment = (e, id) => {
    confirmAlert({
      title: "",
      message: "Are you sure you want to delete this record?",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.deleteCommentApi(e, id),
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  deleteCommentApi = async (e, id) => {
    this.setState({ deleteFlag: false });
    var bodyFormData = { id: id, question_id: this.props.question };
    let res = null;
    try {
      res = await API({
        method: "Delete",
        url: "delete/question/responseNew",
        data: bodyFormData,
      });
    } catch (error) {
      this.setState({
        deleteFlag: true,
      });
    }

    if (res) {
      if (res.status === 200) {
        //this.props.changeResponseArr(res.data.data);
        //this.setState({qData:res.data.data});
        let data = this.state.data.filter((val) => {
          if (parseInt(val.id) !== parseInt(id)) {
            return val;
          }
        });
        this.setState({
          data: data,
          deleteFlag: true,
        });

        store.dispatch(
          setAlert({
            flag: true,
            type: 1,
            message: res.data.message,
          })
        );
      } else {
        this.setState({ deleteFlag: true });
      }
    }
  };

  showHistoryFunc = () => {
    let arr = this.state.data.map((v) => {
      if (this.state.id === v.id) {
        return v.score;
      }
    });
    let arr1 = arr.filter((va) => {
      if (typeof va === "object") {
        return va;
      }
    })[0];

    let a = arr1.map((v) => {
      return `<tr><td>${this.remarks(v.type)}</td><td>${v.score}/${
        v.from
      }</td><td>${v.remarks}</td></tr>`;
    });

    if ([6, 7, 13].includes(this.state.data[0].question.subcategory_id)) {
      let t_from = 0;
      let t_score = 0;
      for (var i = 0; i <= arr1.length - 1; i++) {
        t_from += arr1[i].from;
        t_score += arr1[i].score;
      }
      a.push(
        '<tr><td>Total</td><td colspan="2">' +
          t_score +
          "/" +
          t_from +
          "</td></tr>"
      );
    }
    return a;
  };

  remarks = (type) => {
    let str = "";
    switch (type) {
      case 0:
        str = "Content";
        break;
      case 1:
        str = "Fluency";
        break;
      case 2:
        str = "Pronunciation";
        break;
      case 3:
        str = "Score";
        break;
      case 4:
        str = "Grammar";
        break;
      case 5:
        str = "Form";
        break;
      case 6:
        str = "Vocabulary";
        break;
      case 7:
        str = "Spelling";
        break;
      case 8:
        str = "Linguistic range";
        break;
      case 9:
        str = "Structure";
        break;
      default:
        str = "";
    }
    return str;
  };

  otherData = () => {
    let data = this.state.data
      .map((v) => {
        if (this.state.id === v.id) {
          return v;
        }
      })
      .filter((va) => {
        if (typeof va === "object") {
          return va;
        }
      })[0];

    return (
      <div className="mt-4 text-center">
        <h3>User Response</h3>
        {data.html != "undefined" &&
          data.question.subcategory_id !== 10 &&
          ReactHtmlParser(data?.html)}
        {data.html != "undefined" &&
          data.question.subcategory_id === 10 &&
          data.html
            .split("<br />")
            .filter((va) => {
              if (va !== "") {
                return va;
              }
            })
            .map((v) => {
              return ReactHtmlParser(
                '<li class="list-group-item1">' + v + "</li>"
              );
            })}

        {[3, 4].includes(data.question.subcategory_id) && (
          <div>
            <div className="AIScoreCom__Category-sc-1yzm0aw-12 liAXDW">
              <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJgd"></div>
                Good
              </div>
              <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJav"></div>
                Average
              </div>
              <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca"></div>
            </div>
          </div>
        )}

        {[1, 2].includes(data.question.subcategory_id) && (
          <div>
            <div className="AIScoreCom__Category-sc-1yzm0aw-12 liAXDW">
              <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJgd"></div>
                Good
              </div>
              <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJbad"></div>
                Bad pronunciation/Missed words
              </div>
              <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca"></div>
            </div>
          </div>
        )}

        {[6, 7].includes(data.type) && (
          <div className="para-form">{ReactHtmlParser(data.answer)}</div>
        )}

        {[13, 11, 12, 16, 19].includes(data.question.subcategory_id) &&
          ReactHtmlParser(data.answer)}

        {data.file && (
          <div>
            <audio
              className="mt-4"
              src={s3base + "/ptedata/ptemedia/" + data.file}
              controls="controls"
            />
          </div>
        )}
      </div>
    );
  };

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };

  viewScorePopup = (e, val) => {
    const { id, score, question } = val;

    // open template detected popup only for describe image.
    if ([3,4].includes(question.subcategory_id)) {
      const { practice_question_template_detected } = val;

      // show template detected popup if its detected.
      if (practice_question_template_detected !== null) {
        const { sentence, type } = practice_question_template_detected;
        
        this.setState({
          id,
          explanationModal: true,
          popupData: {
            template_type: type,
            title: sentence,
            data: {
              overallScore: {
                label: "Overall Score",
                score: 10,
                out_of: 90
              },
              contentScore: {
                label: "Content",
                score: 10,
                out_of: 90
              },
              fluencyScore: {
                label: "Fluency",
                score: 10,
                out_of: 90
              },
              pronunciationScore: {
                label: "Pronunciation",
                score: 10,
                out_of: 90
              },
              remarks: val.score[0].remarks
            }
          }
        });
      } else {
        // template not detected. Open normal popup.
        this.showScore(e, id, question.subcategory_id);
      }
    } else {
      // open score popup only.
      this.showScore(e, id, question.subcategory_id);
    }
  }

  render() {
    if (this.props.flag === 1) {
      return (
        <div>
          {this.state.modal && (
            <Modal isOpen={this.state.modal} size="lg">
              <ModalBody>
                <Table>
                  <tbody>
                    <tr>
                      <th>Component</th>
                      <th>Score</th>
                      <th>Remarks</th>
                    </tr>
                    {this.showHistoryFunc().map((v) => {
                      return ReactHtmlParser(v);
                    })}
                  </tbody>
                </Table>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  className="modalCloseBtn"
                  onClick={this.toggle}
                >
                  Close
                </Button>
              </ModalFooter>
            </Modal>
          )}

          {this.state.data && (
            <Button
              color="primary"
              className="viewResultbtn remarksbtn"
              onClick={(e) => this.showScore(e, this.props.id)}
              size="sm"
            >
              View scores with remarks
            </Button>
          )}
        </div>
      );
    }

    return (
      <>
        {this.state.explanationModal && (
          <TemplateDetectorModal
            isOpen={this.state.explanationModal}
            data={this.state.popupData.data}
            template_type={this.state.popupData.template_type}
            title={this.state.popupData.title}
            closeModal={this.closeModalExplanation}
          />
        )}

        <Row>
          {this.state.modal && (
            <Modal isOpen={this.state.modal} size="lg">
              <ModalBody>
                <Table>
                  <tbody>
                    <tr>
                      <th>Component</th>
                      <th>Score</th>
                      <th>Remarks</th>
                    </tr>
                    {this.showHistoryFunc().map((v) => {
                      return ReactHtmlParser(v);
                    })}
                  </tbody>
                </Table>
                <div>{this.otherData()}</div>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  className="modalCloseBtn"
                  onClick={this.toggle}
                >
                  Close
                </Button>
              </ModalFooter>
            </Modal>
          )}

          <Col xs={12}>
            <div>
              <CardBody>
                <Table>
                  <thead className="text-primary">
                    <tr></tr>
                  </thead>
                  <tbody>
                    {this.state.data.map((val, key) => {
                      if (val.user.length === 0) {
                        return false;
                      }

                      return (
                        <tr key={val.id}>
                          {[1, 2, 3, 4, 5, 21, 22].includes(
                            val.question.subcategory_id
                          ) && (
                            <React.Fragment>
                              <td>
                                <h3 className="comment-user">
                                  <img
                                    style={{
                                      width: "57px",
                                      height: "57px",
                                      borderRadius: "41px",
                                    }}
                                    src={
                                      val.user[0].image
                                        ? base + val.user[0].image
                                        : "data:image/jpeg;base64,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"
                                    }
                                  />
                                  &nbsp;&nbsp;{val.user[0].first_name}
                                </h3>
                                <div>
                                  <small>
                                    {val.local_date
                                      ? val.local_date
                                      : val.aus_date + " (AEDT)"}
                                  </small>
                                </div>
                                Score :{" "}
                                {Math.round(
                                  val.score.reduce(
                                    (sum, key) => sum + parseFloat(key.score),
                                    0
                                  )
                                ) +
                                  "/" +
                                  val.score.reduce(
                                    (sum, key) => sum + parseFloat(key.from),
                                    0
                                  )}
                              </td>

                              <td>
                                <audio
                                  src={s3base + "/ptedata/ptemedia/" + val.file}
                                  controls="controls"
                                />
                                <div>
                                  <Button
                                    color="primary"
                                    className="viewResultbtn"
                                    onClick={(e) => this.viewScorePopup(e, val)}
                                    size="sm"
                                  >
                                    View
                                  </Button>
                                  {store.getState().user.id === val.user_id && (
                                    <Button
                                      onClick={(e) =>
                                        this.deleteComment(e, val.id)
                                      }
                                      className="btn delete-btn"
                                    >
                                      Delete
                                    </Button>
                                  )}
                                </div>
                              </td>
                            </React.Fragment>
                          )}

                          {[8, 9, 10, 14, 15, 17, 18].includes(
                            val.question.subcategory_id
                          ) && (
                            <React.Fragment>
                              <td>
                                <h3 className="comment-user">
                                  <img
                                    style={{
                                      width: "57px",
                                      height: "57px",
                                      borderRadius: "41px",
                                    }}
                                    src={
                                      val.user[0].image
                                        ? base + val.user[0].image
                                        : "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAMAAACahl6sAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAG2YAABzjgAA+swAAIT6AAB5gQAA/RMAADBtAAASKQ0eJk4AAAMAUExURevr7Jydn5manJucnuPj5JiZm9vb3PT09MvLzMLCw5GSlPr6+qeoqdXV1tHR0rW1trW2uKusrbi4urO0tLq6vKiqq7e4uLW2tqGipLm6ury8vr6+vr+/wLu8vM7OztDQ0cjJytjY2dTU1aipqqqrrMXGxqanqKmqq6Wmp9LT062usKSlprS0ta2trra2t6ytrqWmqK2ur66vsK6ur7CwsbOztK+vsK+wsbKys7GxsqOkpqOkpZ6foampq6qqrJ2eoKenqaysraKjpZqbnbi4uaKjpKSlp5eYmqioqqurrKChory8vKGio6amqKCho7Gys7CxsrGysrKzs5+gop+gobS1tbq6u7e3uLCxsbKztLi4uJWWmJaXmba3t7i5ub29vZWXmZSWmLq6upOVl5SVl7m5up6foLq7u7u7vJqcnZOUlpeZm5aYmpKUlry8vZKTlpGTlZCRlJCRk6ytr9bX197e3q+vsb2+v8DAweDh4bOztebm5ujp6e/v756eoP///4CAgIGBgYKCgoODg4SEhIWFhYaGhoeHh4iIiImJiYqKiouLi4yMjI2NjY6Ojo+Pj5CQkJGRkZKSkpOTk5SUlJWVlZaWlpeXl5iYmJmZmZqampubm5ycnJ2dnZ6enp+fn6CgoKGhoaKioqOjo6SkpKWlpaampqenp6ioqKmpqaqqqqurq6ysrK2tra6urq+vr7CwsLGxsbKysrOzs7S0tLW1tba2tre3t7i4uLm5ubq6uru7u7y8vL29vb6+vr+/v8DAwMHBwcLCwsPDw8TExMXFxcbGxsfHx8jIyMnJycrKysvLy8zMzM3Nzc7Ozs/Pz9DQ0NHR0dLS0tPT09TU1NXV1dbW1tfX19jY2NnZ2dra2tvb29zc3N3d3d7e3t/f3+Dg4OHh4eLi4uPj4+Tk5OXl5ebm5ufn5+jo6Onp6erq6uvr6+zs7O3t7e7u7u/v7/Dw8PHx8fLy8vPz8/T09PX19fb29vf39/j4+Pn5+fr6+vv7+/z8/P39/f7+/v///zfARREAAAeqSURBVHja7N3xVxJZFMBxQAQVilzPSTslBxcDdwdtBQRBDQUFBYNMDTcoNLAMM7QD23JozvvX94cJZBhQZ+bdO2/26F/Q59wv8K48JwP5n/wY7iH3kHvIPYT6D89bLBazfiF8Y+T09PT09MOHzc3Nd+8yeoTwb99+/PjkSbfj8eN83qYPSCOTOTs7O3veEP69UkcegEIdMpPJCI6zz5/f9p9HPp9//97KMsTwLZO5o2Nh4RmrkHrpmxzHwsICzyLEWSq1IXd1TE6aWYNYSqVSqSRzHpOTDsdDliC2ksBQ4HA4zOxA6iURRJ7DccizAbE9fVpyNXhlXTkcjsNDHxMQKyGEWBV35Tg89Pl8rKTVUtHVoc/n89mYgPBK3686Dt8EIcQwMzOjKUTF+1XHMbG0tLT095s3y8vL77WCqHq/Ehy+Lsdybm9aC4irRKGrLkcut7cXiUTQIS1588jfPo/cXiQSibxGhtTpdyU4kCElyq/zXMdx9AwT0qI+j1zbEQwiQmyUX+fXXR0Fg0EXGsQK1dXRUTAYDIbRIJBdBYNhNIgFsqtgOBx2IkFguwqHQyEcSAu2q3AICwLcVSjEh1oYEPCuQgbix4A4obsK+QmPAwHtKhTy+3+gvEacsF2F/H5/wIAIAevK7/cHAhgQgPNuzzwCgcAiFgSoK3/bgQWhuUdJuwosYkGgu1pcnDdgQCju5wPmMY8CAeyqPY/5+To8BKErPAjY50fb8QIHAnIu6Z7HCxwI0Lmk24ECge8KB4LQ1YuNDYS3X4SuNjbGESAIXW2M40DAuxofH0c4ayF0hQNB6AoJAt8VDgShq/GdHQwIYFfteezMIkCgzrsiBwZkhPp+LulqFgXyB/X9XDoPFEgTviscCE99P+/+/PjlwIAQ6vu5dB4vX2JAALvaaTu8OBCoc0m7q5deHAjYuaQzD68fAwJ3Luk4vC4MyAh4V17vAwxIE7orr9fLY0AIdFde7xpBg8B09cuBCAHtyrvmxoLAdrXm/h0DUgfvas3tdvPQEBdCV2632+3eHgWFwL9ftR12+yYg5CfIfi7pyu3ettvtdkAI2B4lnYfdbndBQiD28wGO9XUwiAFmP5e8zu0CxGOFgrgQu1pf93hcUJA84HlX/DoXIDkoCNB+3r8rj8fjgYIA7ef9u4KGoHXl8XheAUKAzyXdXXlezcFBwM8lXV29moODoHY1BwfB7QoSgtoVIARuj+rXFTAEtCvxPJKPoCBm1K6SyZ9gx3jorrodc0kObh/B7CrJzQJCELviZA1EJsQAtp9LuwKFENA9SjwPbhoSYgbbzwVGl0PeQGT/gg5sP+/tipuFhRCkruQORD5kFPa8qzAsJb/Ehj3v/uqKM8NDSANmPxd11cD5fgS8K5Q/3yOE2L7l9vYWALpKPuI4jsP7M3DhB+JcovyBbmoeJ0K/K45oASG0u0py09pAND7v0oM0qe7nSU4zCKG7R2kJofw5yGsFcVLcz1UOROXztah2pSWE6vkqatUO0qS2n3McFyXaQYiP2h6l0qH6qYCU9nMuGmUBon6P4qLRh9pCrJS6UjsQ9Q+cXKKwR3HRaPQfrSGESlfRFaI5pK7284OKg8aDiyl0tcIEpKV4j6LooPIoaYParlZ4NiBE2X5+7fiXMAIh6rpaIcxAeDVdUXHQem78A/n7ecfRYAlCphXsURTnQfG/JJC/RwkO9iCy9yjBEWcNoqyrlTiTEPldxZmEKOgqHt9iDyL782MlHo9vsQeRtZ9fO5iDyNyjOg72IIq62tqaYg0ib4+6drAJkd3VFJMQBV1NTe2yC5HTFZOQO+9R3fPYZQ4iu6spwcEq5PY9StTV7m6WLYjtVFlXu9nsCDMQi9+ruKtsNptOp9N/WTWHmJ/I2s8l88im0+n0/v7+Qc6mHcSiZI8a4Dg4OFhdVXGnRjHks9I9StpVx7G6uvrpU8yJCHmudD+/cR6CIxaLxR5gQJT/3ufOjljMaDQ6ASHN18q+P5fRVcdhNBqNQ9tWAEhL+ffnCuZhNBqNQ0NDQ0N+qpCmyu85lTu+fEkkEnYLDcio6u/PFXbVcSQSiYTJ5FQFeU7le0518xAcJpPJNKMMUqL0/Tk1h2l4eHh4RB6kPkHlHvKA827HsS/bMXx+nvqtdUcItfvt9OcxfH6eSqVSqa8/boU06d2/AnR8LRaLN0Pq9O6339aVckfqa7FYLB7fBKF0DxlhHsXj42PjQEgIqqspCEehUBgA8dG5347S1fFxoVAo2PpCWrrqqlAoFE5OWn0gBr11VTg5Oan0gdC63w45j1Svo2KVQujdQ8bq6qRSqVQkkAlq95DxuqpUKmUJhNb9dsyuKpVyeVQC0WNX5XK52gOx6LKrcrlabYghE5Tut+N2VS5Xq3YxhNo9ZNyuqtXqhQhipXS/HburavVCDKkzvUcN7qp60QPZ1GtXFxc1EYTV/fwaMmgetV4Iu/v5jV3VarW6CML2fj64q1qt9mc3hPX9fPA8ape9ED3sUX3mcXl5KYboY4/q5xgTQdjfz/t31QvRb1djYz0QvXYlhbC/n/ftqgeinz1KMo8eiG72KKlDBNHPHtXbVT+ILrsaG7vqgei0q6ur770QfXZ19V2A/DcAHpmC7NcZ4/wAAAAASUVORK5CYII="
                                    }
                                  />
                                  &nbsp;&nbsp;{val.user[0].first_name}
                                </h3>
                                <div>
                                  <small>{val.aus_date + " (AEDT)"}</small>
                                </div>
                                Score :{" "}
                                {val.score.reduce(
                                  (sum, key) => sum + parseFloat(key.score),
                                  0
                                ) +
                                  "/" +
                                  val.score.reduce(
                                    (sum, key) => sum + parseFloat(key.from),
                                    0
                                  )}
                              </td>

                              <td>
                                {ReactHtmlParser(val.html)}
                                <br />
                                <Button
                                  className="viewResultbtn"
                                  onClick={(e) => this.showScore(e, val.id, val.question.subcategory_id)}
                                  size="sm"
                                >
                                  View
                                </Button>
                                {store.getState().user.id === val.user_id && (
                                  <Button
                                    onClick={(e) =>
                                      this.deleteComment(e, val.id)
                                    }
                                    className="btn delete-btn"
                                  >
                                    Delete
                                  </Button>
                                )}
                                <div></div>
                              </td>
                            </React.Fragment>
                          )}

                          {[11, 12, 20, 19, 16, 6, 7, 13].includes(
                            val.question.subcategory_id
                          ) && (
                            <React.Fragment>
                              <td>
                                <h3 className="comment-user">
                                  <img
                                    style={{
                                      width: "57px",
                                      height: "57px",
                                      borderRadius: "41px",
                                    }}
                                    src={
                                      val.user[0].image
                                        ? base + val.user[0].image
                                        : "data:image/jpeg;base64,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"
                                    }
                                  />
                                  &nbsp;&nbsp;{val.user[0].first_name}
                                </h3>
                                <div>
                                  <small>{val.aus_date + " (AEDT)"}</small>
                                </div>
                                Score :{" "}
                                {val.score.reduce(
                                  (sum, key) => sum + parseFloat(key.score),
                                  0
                                ) +
                                  "/" +
                                  val.score.reduce(
                                    (sum, key) => sum + parseFloat(key.from),
                                    0
                                  )}
                              </td>

                              <td className="para-form">
                                {ReactHtmlParser(val.answer)}
                                <br />

                                <div className="mt-3">
                                  <Button
                                    color="primary"
                                    className="viewResultbtn"
                                    onClick={(e) => this.showScore(e, val.id,  val.question.subcategory_id)}
                                    size="sm"
                                  >
                                    View
                                  </Button>

                                  {this.state.deleteFlag &&
                                    store.getState().user.id ===
                                      val.user_id && (
                                      <Button
                                        onClick={(e) =>
                                          this.deleteComment(e, val.id)
                                        }
                                        className="btn delete-btn"
                                      >
                                        Delete
                                      </Button>
                                    )}
                                </div>
                                <div></div>
                              </td>
                            </React.Fragment>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>

                {this.state.load_flag && (
                  <h3 className="text-center">Loading...</h3>
                )}

                {!this.state.load_flag && this.state.data.length === 0 && (
                  <h4 className="text-center">No data found.</h4>
                )}

                {/* {this.state.loadMoreFlag && !this.state.load_flag && <Button onClick={(e)=>{this.getData()}}>Load more</Button>} */}
              </CardBody>
            </div>
          </Col>
        </Row>
      </>
    );
  }
}

export default ShowHistory;
